<!-- Presales Sidebar -->
<p-drawer [closeOnEscape]="false" [(visible)]="showSidebar" [showCloseIcon]="true" position="right" [blockScroll]="true" [dismissible]="false" styleClass="w-full payment-sidebar no-header p-0" (onHide)="closeNotificationSidebar()">
    <!-- Header -->
     <ng-template #headless>
    <div class="border-bottom-1 border-300 relative flex align-items-center justify-content-between sticky left-0 top-0 w-full surface-0 z-5 p-2">
        <div class="flex align-items-center">
            <div (click)="closeNotificationSidebar()" class="h-2rem w-2rem cursor-pointer surface-200 flex align-items-center justify-content-center"><i class="fa fa-times text-xl text-600"></i></div>
            <label  class="font-bold cursor-pointer text-sm mx-2">{{'STAFF_NOTIFICATIONS.DIRECT_NOTI' | translate}}</label>
            <p-toggleSwitch (onChange)="showDirectNotifications(directNotifications)"></p-toggleSwitch>
        </div>

        <p-button [label]="'STAFF_NOTIFICATIONS.BTN_MARK_ALL_READ' | translate" (onClick)="markAllAsRead()" styleClass="p-button-text text-xs"></p-button>
    </div>
    <!-- Header -->

    <!-- Content -->
    <p-scrollPanel styleClass="w-full h-screen" *ngIf="currentTenantNotifications.value.length > 0 || otherTenantNotifications.value.length > 0; else showNoNotification">
        <ul class="list-none p-0 m-0">
            <li class="flex py-3 pl-3 pr-5 border-bottom-1 border-300 relative" *ngFor="let data of currentTenantNotifications.getValue()" [ngClass]="!data.is_read ? 'bg-blue-50' : ''">
                <div class="flex align-items-center relative cursor-pointer" (click)="openClientSidebar(data)">
                    <i *ngIf="!data.is_read" class="fa fa-circle text-primary text-xxs"></i>
                    <p-avatar [image]="data.client.image"  [label]="!data.client?.image ? (data.client?.full_name | titlecase | shortName) : ''" styleClass="ml-2 md:h-3rem md:w-3rem" shape="circle"></p-avatar>
                    <div [ngClass]="getClass(data)" class="text-white flex align-items-center justify-content-center p-1 border-round absolute right-0 top-0 -mr-3 mt-2">
                        <i [ngClass]="getIcon(data)"></i>
                    </div>
                </div>
                <div class="text-sm ml-4 cursor-pointer" (click)="openClientSidebar(data)">
                    <div><span class="font-bold">{{ data.client && data.client.full_name ? data.client.full_name : '' }}</span> {{ 'STAFF_NOTIFICATIONS.'+getReplyText(data) | translate }} <span class="font-bold">"{{ getInteractionContent(data.payload.content) }}"</span></div>
                    <div class="flex align-items-center text-600 mt-2">
                        <span class="text-xxs"> {{ data.created_date | DayAgo }} </span>
                        <span class="mx-2 text-3xl line-height-1 -mt-3 border-circle">.</span>
                        <span class="surface-300 p-1 border-round text-xs" *ngIf="isDirectNotification(data)">{{'STAFF_NOTIFICATIONS.DIRECT' | translate}}</span>
                    </div>
                </div>
                <i class="fa fa-times text-xl cursor-pointer absolute right-0 top-0 mt-4 mr-4 text-600" (click)="markAsDelete(data)"></i>
            </li>
        </ul>
        <div class="p-3">
            <!-- Notification Box -->
            <div class="surface-200 cursor-pointer p-3 border-round text-sm mb-2" *ngFor="let data of otherTenantNotifications.getValue();trackBy: trackByFn">
                <div class="flex align-items-center justify-content-between" (click)="toggleInfo(data)">
                    <div class="flex align-items-center">
                        <p-badge [value]="data.notifications.length" severity="danger"></p-badge>
                        <div class="mx-2">{{'STAFF_NOTIFICATIONS.NEW_NOTI_FOR' | translate}} <strong class="font-bold">{{ getTenantName(data.tenantId) }}</strong></div>
                    </div>
                    <div class="text-xxs text-600 white-space-nowrap">{{ data.notifications[0].created_date | DayAgo }}</div>
                </div>
                    <div class="-mt-1 -mb-3" *ngIf="data.showInfo">
                        <p-message severity="info" icon="fa fa-info-circle" aria-label="change-branch-to-message">
                            <div class="flex align-items-center w-full -my-2 md:m-0">
                                    <i class="fa fa-info-circle text-xl"></i>
                                    <div class="ml-3 text-sm">{{'STAFF_NOTIFICATIONS.CHANGE_BRANCH_TO' | translate}} <strong class="font-bold">{{ getTenantName(data.tenantId) }}</strong> {{'STAFF_NOTIFICATIONS.BTANCH_TO_VIEW' | translate}}</div>
                                </div>
                        </p-message>
                    </div>
            </div>
            <!-- Notification Box -->

            <!-- Notification Box -->
            <div class="surface-200 cursor-pointer p-3 border-round text-sm mb-2" *ngIf="remainingCount() > 0">
                <div class="flex align-items-center justify-content-between" (click)="loadMoreNotifications()">
                    <strong class="w-full text-primary text-center block" [innerText]="'STAFF_NOTIFICATIONS.LOAD_MORE' | translate : {count : remainingCount()}" ></strong>
                </div>
            </div>
            <!-- Notification Box -->
        </div>
    </p-scrollPanel>
    <!-- Content -->

     <!-- Content -->
      <ng-template #showNoNotification>
        <div class="text-center py-6" >
            <p class="text-sm mb-4">{{ 'STAFF_NOTIFICATIONS.NO_NOTIFICATION' | translate }}</p>
            <img src="/assets/img/img-no-notifications.svg" [alt]="'STAFF_NOTIFICATIONS.NO_NOTIFICATION' | translate" >
        </div>
      </ng-template>
  
     <!-- Content -->
     </ng-template>

</p-drawer>
<!-- Presales Sidebar -->

<client-info-sidebar *ngIf="showClientSidebar" [showClientSidebar]="showClientSidebar" [activeClientId]="activeClientId" [interactionId]="interactionId" (closeSidebar)="CloseSidebar($event)"> </client-info-sidebar>
